import CodeActivation from "@/modules/code_activation/components/CodeActivation";
import CodeActivationDetail from "@/modules/code_activation/components/CodeActivationDetail";
import CodeActivationForm from "@/modules/code_activation/components/CodeActivationForm";

export default [
    {
        path: "/code-activation",
        name: "CodeActivation",
        component: CodeActivation,
    },
    {
        path: "/code-activation-detail",
        name: "CodeActivationDetail",
        component: CodeActivationDetail,
    },
    {
        path: "/code-activation-form",
        name: "CodeActivationForm",
        component: CodeActivationForm,
    },
];



// WEBPACK FOOTER //
// ./src/modules/code_activation/router/code_activation.js